import { useFormContext } from "react-hook-form";
/**
 * Extending react-hook-form to pre-filter via touched
 */
export default (fieldName) => {
    var _a;
    const { control, formState: { errors, dirtyFields }, } = useFormContext();
    const formError = (_a = errors.root) === null || _a === void 0 ? void 0 : _a.formError;
    // I don't like these type casts but can't bother right now
    const isDirty = dirtyFields[fieldName];
    const error = errors[fieldName];
    return {
        control,
        isError: isDirty && (!!error || !!formError),
        error: isDirty ? error === null || error === void 0 ? void 0 : error.message : undefined,
    };
};
